function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-899 -208)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 7",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(899 208)",
  fill: "#002f4d"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-attach-money",
  d: "M911.694 218.363c-2.1-.545-2.771-1.108-2.771-1.986 0-1.014.93-1.714 2.494-1.714 1.644 0 2.253.785 2.309 1.939h2.041a3.681 3.681 0 00-2.965-3.519v-2.02h-2.77v1.995c-1.792.388-3.232 1.552-3.232 3.334 0 2.133 1.764 3.2 4.341 3.814 2.309.554 2.771 1.367 2.771 2.226 0 .637-.453 1.653-2.494 1.653-1.9 0-2.651-.85-2.752-1.939h-2.033a3.869 3.869 0 003.4 3.537v2h2.771v-1.982c1.8-.342 3.232-1.385 3.232-3.279-.001-2.622-2.246-3.518-4.342-4.059z",
  fill: "#fdfdfd"
}));
var SvgPay = function SvgPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};
export default SvgPay;